module.exports = __webpack_public_path__ + "static/media/2.dee422e0.png";